export const BUTTON_HIDE_TEXT = `Скрыть`;
